import {takeLatest, put, call} from "redux-saga/effects";
import * as Actions from "./actions";
import ActionTypes from "./actionTypes";
import AuthenticationConfig from "../config";

function* login(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    const user = yield call(backend.login, action.payload);
    AuthenticationConfig.onLoginSuccess(user, {
      fromAccessToken: !!action.payload.accessToken,
    });
    yield put(Actions.requestUserLoginSuccess(user));
    yield put(Actions.loadUserProfile());
  } catch (error) {
    AuthenticationConfig.onLoginFailure(error);
    yield put(Actions.requestUserLoginFailure(error));
  }
}
export function* loginSaga() {
  yield takeLatest(ActionTypes.REQUEST_USER_LOGIN, login);
}

function* logout(action) {
  try {
    AuthenticationConfig.onLogout();
    yield put(Actions.requestUserLogoutSuccess());
  } catch (error) {
    yield put(Actions.requestUserLogoutFailure(error));
  }
}
export function* logoutSaga() {
  yield takeLatest(ActionTypes.REQUEST_USER_LOGOUT, logout);
}

function* register(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    const newUser = yield call(backend.register, action.payload);
    const user = newUser.requiresLogin ? null : newUser;
    AuthenticationConfig.onRegistrationSuccess(user);
    yield put(Actions.requestUserRegistrationSuccess(user));
    if (!newUser.requiresLogin) {
      yield put(Actions.loadUserProfile());
    }
  } catch (error) {
    AuthenticationConfig.onRegistrationFailure(error);
    yield put(Actions.requestUserRegistrationFailure(error));
  }
}
export function* registerSaga() {
  yield takeLatest(ActionTypes.REQUEST_USER_REGISTRATION, register);
}

function* updateUser(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    const user = yield call(backend.updateUser, action.payload);
    yield put(Actions.requestUpdateUserSuccess(user));
    yield put(Actions.loadUserProfile());
  } catch (error) {
    yield put(Actions.requestUpdateUserFailure(error));
  }
}
export function* updateUserSaga() {
  yield takeLatest(ActionTypes.REQUEST_UPDATE_USER, updateUser);
}

function* deactivateUser(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    yield call(backend.deactivateUser);
    AuthenticationConfig.onLogout();
    yield put(Actions.requestDeactivateUserSuccess());
  } catch (error) {
    yield put(Actions.requestDeactivateUserFailure(error));
  }
}
export function* deactivateUserSaga() {
  yield takeLatest(ActionTypes.REQUEST_DEACTIVATE_USER, deactivateUser);
}

function* loadUserProfile() {
  const backend = AuthenticationConfig.getBackend();
  try {
    let user = yield call(backend.loadUserProfile);
    AuthenticationConfig.onUserProfileFetched(user);
    yield put(Actions.loadUserProfileSuccess(user));
  } catch (error) {
    yield put(Actions.loadUserProfileFailure(error));
  }
}
export function* loadUserProfileSaga() {
  yield takeLatest(ActionTypes.LOAD_USER_PROFILE, loadUserProfile);
}

function* loadUser(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    let user = yield call(backend.loadUserProfile, action.payload);
    AuthenticationConfig.onLoginSuccess(action.payload);
    AuthenticationConfig.onUserProfileFetched(user);
    yield put(Actions.loadUserProfileSuccess(user));
  } catch (error) {
    console.log("Error loading user", error);
    yield put(Actions.requestUserLogout());
  }
}
export function* loadUserSaga() {
  yield takeLatest(ActionTypes.LOAD_USER, loadUser);
}

function* recoverPassword(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    const data = yield call(backend.recoverPassword, action.payload);
    yield put(Actions.requestRecoverPasswordSuccess(data));
  } catch (error) {
    yield put(Actions.requestRecoverPasswordFailure(error));
  }
}
export function* recoverPasswordSaga() {
  yield takeLatest(ActionTypes.REQUEST_RECOVER_PASSWORD, recoverPassword);
}

function* resetPassword(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    const user = yield call(backend.resetPassword, action.payload);
    yield put(Actions.requestResetPasswordSuccess(user));
    AuthenticationConfig.onLoginSuccess(user);
    yield put(Actions.loadUserProfile());
  } catch (error) {
    yield put(Actions.requestResetPasswordFailure(error));
  }
}
export function* resetPasswordSaga() {
  yield takeLatest(ActionTypes.REQUEST_RESET_PASSWORD, resetPassword);
}

function* changePassword(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    const data = yield call(
      backend.changePassword,
      action.payload.currentPassword,
      action.payload.password,
      action.payload.confirmPassword
    );
    yield put(Actions.requestChangePasswordSuccess(data));
  } catch (error) {
    yield put(Actions.requestChangePasswordFailure(error));
  }
}
export function* changePasswordSaga() {
  yield takeLatest(ActionTypes.REQUEST_CHANGE_PASSWORD, changePassword);
}

function* accountVerification(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    const data = yield call(backend.accountVerification, action.payload);
    yield put(Actions.requestAccountVerificationSuccess(data));
  } catch (error) {
    yield put(Actions.requestAccountVerificationFailure(error));
  }
}
export function* accountVerificationSaga() {
  yield takeLatest(ActionTypes.REQUEST_ACCOUNT_VERIFICATION, accountVerification);
}

function* accountVerificationCheck(action) {
  const backend = AuthenticationConfig.getBackend();
  try {
    const user = yield call(backend.accountVerificationCheck, action.payload);
    yield put(Actions.requestAccountVerificationCheckSuccess(user));
    AuthenticationConfig.onLoginSuccess(user);
    yield put(Actions.loadUserProfile());
  } catch (error) {
    yield put(Actions.requestAccountVerificationCheckFailure(error));
  }
}
export function* accountVerificationCheckSaga() {
  yield takeLatest(
    ActionTypes.REQUEST_ACCOUNT_VERIFICATION_CHECK,
    accountVerificationCheck
  );
}
